import { render, staticRenderFns } from "./SupercardPurchaseTypeForm.vue?vue&type=template&id=3236e671&"
import script from "./SupercardPurchaseTypeForm.vue?vue&type=script&lang=js&"
export * from "./SupercardPurchaseTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports